import React from "react";

/** The naming card's keycap pair: "esc Cancel" and "↵ {confirmText}". */
export function KeyActions({
  confirmText,
  cancelText = "Cancel",
  danger = false,
  busy = false,
  disabled = false,
  cancelDisabled = false,
  autoFocus = false,
  className,
  onConfirm,
  onCancel,
  onMouseDown,
}: {
  confirmText: string;
  cancelText?: string;
  danger?: boolean;
  busy?: boolean;
  disabled?: boolean;
  cancelDisabled?: boolean;
  autoFocus?: boolean;
  className?: string;
  onConfirm: () => void;
  onCancel: () => void;
  onMouseDown?: React.MouseEventHandler;
}): React.JSX.Element {
  return (
    <span className={className} onMouseDown={onMouseDown}>
      {/* eslint-disable-next-line no-restricted-syntax -- the naming card's keycap pair */}
      <button
        type="button"
        className="naming-cancel"
        onClick={onCancel}
        disabled={cancelDisabled}
      >
        <kbd className="naming-key">esc</kbd>
        {cancelText}
      </button>
      {/* eslint-disable-next-line no-restricted-syntax -- the naming card's keycap pair */}
      <button
        type="button"
        autoFocus={autoFocus}
        className={`naming-create${danger ? " naming-danger" : ""}`}
        onClick={onConfirm}
        disabled={disabled || busy}
        aria-busy={busy || undefined}
      >
        {busy ? (
          <span className="naming-spin" aria-hidden />
        ) : (
          <kbd className="naming-key">↵</kbd>
        )}
        {confirmText}
      </button>
    </span>
  );
}
